import React from 'react';
import flagEn from '../images/flag-us.svg';
import flagSe from '../images/flag-se.svg';
import themeIcon from '../images/sunrise-line.svg';
import { useTranslation } from '../i18n';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../firebaseConfig';

const Footer = ({ handleThemeChange, theme }) => {
  const { t, changeLanguage } = useTranslation();
  return (
    <div key="i18n" className="footer">
      <div className="flex-row gap-100">
        <button
          className="btn btn-sm btn-icon btn-flag"
          onClick={() => (
            changeLanguage('en'),
            logEvent(analytics, 'hero_settings_language', {
              language: 'en',
            })
          )}
        >
          <img src={flagEn} width={24} height={18} alt="Flag icon" />
          English
        </button>
        <button
          className="btn btn-sm btn-icon btn-flag"
          onClick={() => (
            changeLanguage('sv'),
            logEvent(analytics, 'hero_settings_language', {
              language: 'sv',
            })
          )}
        >
          <img src={flagSe} width={24} height={18} alt="Flag icon" />
          Svenska
        </button>
      </div>
      <div className="separator-vertical"></div>
      <div className="flex-row">
        <button
          className="btn btn-sm btn-icon btn-theme"
          onClick={() => (
            handleThemeChange(theme === 'dark' ? 'light' : 'dark'),
            logEvent(analytics, 'hero_settings_theme', {
              theme: theme === 'dark' ? 'light' : 'dark',
            })
          )}
        >
          <img src={themeIcon} width={24} height={18} alt="Flag icon" />
          {theme === 'dark' ? t.theme.light : t.theme.dark}
        </button>
      </div>
    </div>
  );
};

export default Footer;
